<template lang="pug">
  span.radio(:class="{radio_active:isActive, disabled:disabled}" @click.stop.prevent="clickHandle")
   i.icon(:class="{radio_active:isActive}" v-if="!group" v-show="isActive && !disabled")
   i.icon(v-show="!isActive && !disabled" v-if="!group")
   label(v-if="!$slots.default") {{ label }} 
   label(v-else)
    slot
</template>

<script>
import emitter from '../../src/mixins/emitter.js'
export default {
  name: 'km-radio',
  props: {
    value: '',
    label: {
      required: true
    },
    disabled: {
      default: false
    }
  },
  inject: {
    group: {
      default: null
    }
  },
  mixins: [emitter],
  computed: {
    isActive() {
      return this.rel_value === this.label
    },
    rel_value() {
      return this.group ? this.group.value : this.value
    }
  },
  methods: {
    clickHandle() {
      if (this.rel_value !== this.label && !this.disabled) {
        this.$emit('input', this.label)
        this.$emit('change', this.label)
        this.dispatch('km-radio-group', 'change', this.label)
        this.dispatch('km-form-item', 'change')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.radio {
  cursor: pointer;
  margin-right: 20px;
}
.radio.disabled {
  cursor: not-allowed;
}
.radio:last-of-type {
  margin-right: 0;
}
.radio_active {
  color: #24cc7c;
}
.radio_active label {
  color: #24cc7c;
}
.icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-image: url('../../image/icon_common.png');
  background-position-x: -48px;
  vertical-align: middle;
  margin-right: 8px;
}
.icon.radio_active {
  background-position-x: -32px;
}
label {
  cursor: pointer;
  display: inline-block;
}
.radio.disabled label {
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/ui/components/radio/main.vue